import { render, staticRenderFns } from "./topSalemoney.vue?vue&type=template&id=0683a09a&scoped=true"
import script from "./topSalemoney.vue?vue&type=script&lang=js"
export * from "./topSalemoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683a09a",
  null
  
)

export default component.exports